var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGlobe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    viewBox: "0 0 96 96"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1 6.8c-3.8 3.3-8.2 10.6-10.1 17-7.5 24.1 8 49 33.3 53.7 3.3.6 3.7 1.1 3.7 3.6 0 2.8-.2 2.9-4.7 2.9-5.7 0-7.6 1-7.1 3.6.3 1.8 1.4 1.9 14.8 1.9h14.5V87c0-2.3-.4-2.5-5.7-2.8-5.6-.3-5.8-.4-5.8-3s.5-2.9 7-4.5c7.2-1.9 18.1-8.2 19.8-11.4.5-1 .7-2.4.5-3.1-.8-2.1-3.9-1.3-8.4 2.3-2.4 1.9-7.3 4.4-10.8 5.5-17.9 5.6-35.3-1.9-43.5-19-2.7-5.7-3.1-7.5-3.1-15 0-7.2.4-9.4 2.9-14.7 1.5-3.4 3.9-7.2 5.2-8.4 4.4-4.1 2-10-2.5-6.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1 8.2c-16.4 6.3-23.8 26.5-15.4 41.9 12.3 22.7 45.2 20.3 54.4-4C85 22.4 61-1 37.1 8.2zm18 5C63.8 15.7 72 26.6 72 35.6c0 8.8-5.5 18-13.2 22-4.2 2.2-12.7 2.9-17.4 1.4-6.9-2.2-11.2-5.8-14.4-12.3-4.7-9.4-3.8-18.1 2.9-25.8 6.3-7.5 16.1-10.5 25.2-7.7z"
  })));
}

export default SvgGlobe;